class AccessibilityHelper {
    /**
     * add accessibility labels that can change dynamically
     * @param type
     * @param input
     * @param collapsible
     * @param state
     * @param role
     */
    static addAccessibilityLabels(type, input, collapsible, state, role) {
        let ariaAttribute = '';
        if (role === 'button') {
            input.setAttribute('role', 'button');
            ariaAttribute = 'aria-pressed';
        }
        if (type === 'checkbox') {
            ariaAttribute = 'aria-checked';
        }
        if (ariaAttribute !== '') {
            input.setAttribute(ariaAttribute, state);
        }

        if (type === 'collapsible' && collapsible) {
            input.setAttribute('aria-expanded', state);
            collapsible.setAttribute('aria-hidden', !state);
        }
    }

    /**
     * switch label on toggle
     * @param type
     * @param input
     * @param collapsible
     * @param role
     */
    static switchLabel(type, input, collapsible, role) {
        const state = input.checked;
        if (type === 'checkbox') {
            input.setAttribute('aria-checked', state);
        }
        if (role === 'button') {
            input.setAttribute('aria-pressed', state);
        }

        if (type === 'collapsible' && collapsible) {
            input.setAttribute('aria-expanded', state);
            collapsible.setAttribute('aria-hidden', !state);
        }
    }

    /**
     * add accessibility label to toggle checkbox buttons
     * and switch in case of change
     * @param type
     * @param input
     * @param collapsible
     * @param state
     * @param role
     */
    static addAndHandleLabelsToggle(type = 'checkbox', input, collapsible, state = false, role = '') {
        AccessibilityHelper.addAccessibilityLabels(type, input, collapsible, state, role);

        input.addEventListener('change', (e) => {
            AccessibilityHelper.switchLabel(type, e.currentTarget, collapsible, role);
        });
    }

    /**
     * @returns {boolean}
     */
    static prefersReducedMotion() {
        const query = '(prefers-reduced-motion: reduce)';
        return window.matchMedia(query).matches;
    }

    static reduceMotion(callback) {
        const motionQuery = window.matchMedia('(prefers-reduced-motion)');

        callback(motionQuery);
        motionQuery.addEventListener('change', () => callback(motionQuery));
    }
}

export default AccessibilityHelper;
